"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiInputLabelOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography;
    return ({
        root: __assign(__assign({}, typography.body1), { lineHeight: 1, textTransform: "unset", color: palette.text.secondary }),
        outlined: {
            margin: 0,
            lineHeight: 1.4,
            transform: "translate(" + spacing(4) + "px, " + spacing(4) + "px) scale(1)",
            "&$shrink": {
                transform: "translate(" + spacing(4) + "px, " + spacing(2) + "px) scale(0.875)",
            },
        },
        asterisk: {
            color: palette.warning.main,
            marginLeft: spacing(1),
        },
    });
};
//# sourceMappingURL=MuiInputLabel.js.map